import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';

interface IProps {
	children: React.ReactNode;
}

const FiltersBar = ({ children }: IProps) => {
	const { tax } = useFiltersContext();

	const taxEntries = Object.entries(tax);

	if (taxEntries.length) {
		return <div className="pfa-filters-bar">{children}</div>;
	}

	return <></>;
};

FiltersBar.displayName = 'FiltersBar';

export default FiltersBar;
